/* base_collector.svg.js */

module.exports = {
    icon: `
        <svg viewBox="3 5 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="foreground-gl" d="M11.9982 13.507C8.71344 13.507 5.9608 12.4581 5.20926 11.0439C5.07713 11.2928 5 11.5515 5 11.8199V14.1341C5 15.9219 8.1341 17.3724 11.9982 17.3724C15.8647 17.3724 19 15.9219 19 14.1341V11.8199C19 11.5515 18.9217 11.2928 18.7884 11.0439C18.0368 12.4574 15.2866 13.507 11.9982 13.507Z" fill="#717171"/>
        <path class="foreground-gl" d="M11.9982 18.8834C8.71344 18.8834 5.9608 17.8332 5.20926 16.4216C5.07713 16.6692 5 16.9279 5 17.1956V19.5118C5 21.3002 8.1341 22.7501 11.9982 22.7501C15.8647 22.7501 19 21.3009 19 19.5118V17.1956C19 16.9279 18.9217 16.6692 18.7884 16.4223C18.0368 17.8332 15.2866 18.8834 11.9982 18.8834Z" fill="#717171"/>
        <path class="foreground-gl" d="M13.4402 7.38409H14.5852H16.3207L12 12.0001L7.67926 7.38409H9.41476H10.5598V2.99854H13.4402V7.38409Z" fill="#717171"/>

        </svg>
`,
};
